<div>
  <label for="scteSync">Sync SCTE Data</label>:
  <input type="checkbox" name="scteSync" [(ngModel)]="viewerState.syncScteData" />
</div>
<br />
<div class="content">
  <div #jsonView>Please Select SCTE CUE</div>
</div>
